import styled, { keyframes } from 'styled-components';
import { Modal } from 'react-bootstrap';

const addAnimation = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const StyledModalContent = styled.div`
  background-color: #f2f2f6;
  border: 2px solid #525252;
  border-radius: 3px !important;
`;

export const StyledModalBackdrop = styled.div`
  content: "";
  background-color: transparent;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
`;

export const StyledModal = styled(Modal)`
  pointer-events: none;
  &.modal-open {
    pointer-events: auto;
  }
`;

export const StyledModalDialog = styled.div`
  max-width: 890px;
`;

export const StyledModalHeader = styled.div`
  background-color: #323232;
  color: #f5f5f5;
  border-radius: 0px;
  border-bottom: 2px solid #525252;
  padding: 1.2rem;
  display: flex;
  justify-content: space-between;
  height: 66px;
  align-items: center;
`;

const ModalBodyWrapper: React.FC = (props) => {
  return <Modal.Body {...props} />;
};

export const StyledModalBody = styled(ModalBodyWrapper)`
  background-color: #2e2e2e;
  overflow: hidden;
`;

export const ModalLeftSide = styled.div`
  transition: background-color 0.5s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const ModalRightSide = styled.div`
  width: calc(100% - 66px);
`;

export const ModalContentWrapper = styled.div`
  display: flex;
  overflow: hidden !important;
  -moz-transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
`;

export const ListItem = styled.div`
  background-color: #2e2e2e;
  color: #f5f5f5;
`;

export const ModalTitle = styled.h5`
  font-size: 1.075rem;
  font-weight: bolder;
  margin-bottom: 0;
  line-height: 1.4;
`;

export const NodeLeading = styled.div<{ $bgColor?: string }>`
  border-radius: 8px;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 27px;
  margin: 8px;
  color: white;
  background-color: ${(props) => props.$bgColor || 'transparent'};
`;

export const ResourcesContainer = styled.div`
  padding-top: 10px;
  padding-bottom: 2px;
  padding-left: 10px;
  white-space: nowrap;
  text-align: left;
  overflow-y: hidden;
  overflow-x: auto;

  &::-webkit-scrollbar {
    height: 8px;
    width: 8px;
    background: #000;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    -webkit-border-radius: 1ex;
    -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.75);
  }
  &::-webkit-scrollbar-corner {
    background: #000;
  }
`;

export const NodeImage = styled.a`
  width: 200px;
  height: 135px;
  margin-right: 8px;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 0.375rem;
  display: inline-block;
  text-decoration: none;
  -moz-transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  animation: ${addAnimation} 1s ease;
  &:hover {
    -moz-transform: scale(1.1);
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
`;

export const ImgThumbnail = styled.div`
  padding: 0.25rem;
  background-color: #fff;
  border: 1px solid var(--bs-border-color);
  border-radius: 0.375rem;
  max-width: 100%;
  height: auto;
  margin-right: 8px;
  border: none;
`;

export const ImageViewerContainer = styled.div`
  width: 100%;
  max-width: 100%;
`;

export const ImgInfo = styled.div`
  display: table;
  padding: 4px 8px 4px 8px;
  border-radius: 8px;
`;

export const CollapseButton = styled.button<{ $collapsed?: boolean }>`
  background-color: transparent;
  padding: 0;
  margin-right: 18px;
  border: none;
  -moz-transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  & i {
    -moz-transition: all 0.3s ease;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
    font-size: 30px !important;
    fill: #f5f5f5;
    transform:  ${(props) => props.$collapsed ? 'rotate(180deg)' : ''};
    transition: transform 0.3s ease;
  }
`;

export const CloseButton = styled.button`
  padding: 0;
  background: transparent;
  border: none;
  & i { font-size: 30px; fill: #f5f5f5 }
`;

export const ModalIcon = styled.i`
  margin-right: 18px;
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  color: #f5f5f5;
`;

export const IconWrapper = styled.div`
  font-size: 25px;
  margin-right: 18px;
  color: #9e9e9e;
`;

export const InfoContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InfoLabel = styled.p`
  margin-bottom: 0;
  color: #9e9e9e;
`;

export const InfoValue = styled.p`
  margin-bottom: 0;
`;

export const PaginationWrapper = styled.div`
  margin-top: 0.5rem;
`;
